import React from 'react';
import {useInView} from 'react-intersection-observer';

import FirstScreen from 'components/blocks/FirstScreen';
import Tariffs from 'components/blocks/Tariffs';
import Care from 'components/blocks/Care';
import ExternalReviews from 'components/blocks/ExternalReviews';
import Marketplace from 'components/blocks/Marketplace';
import Steps from 'components/blocks/Steps';
import Partners from 'components/blocks/Partners';
import OrderStatus from 'components/blocks/OrderStatus';
import Reviews from 'components/blocks/Reviews';
import FAQ from 'components/blocks/FAQ';
import Contacts from 'components/blocks/Contacts';
import OrderSection from 'components/blocks/OrderSection';
import Continue from 'components/blocks/Continue';
import useAnalyticEvent from 'hooks/useAnalyticsEveent';

import './LandingPage.scss';

export default function LandingPage() {
  // eslint-disable-next-line no-unused-vars
  useAnalyticEvent('quick_view', {});
  const [firstScreenRef, isFirstScreenInView] = useInView({});
  const [orderSectionRef, isOrderSectionInView] = useInView({threshold: 0.3});
  const showContinueButton = !isFirstScreenInView && !isOrderSectionInView;

  return (
    <main className="landing-page">
      <FirstScreen innerRef={firstScreenRef} />
      <Tariffs />
      <Care />
      <ExternalReviews />
      <Marketplace />
      <Steps />
      <Partners />
      <OrderStatus />
      <Reviews />
      <FAQ />
      <Contacts />
      <OrderSection innerRef={orderSectionRef} background="dark" />
      {showContinueButton && <Continue />}
    </main>
  );
}
